import CustomerRegister from "@/modules/customer/pages/Register/Register";
import CustomerLogin from "@/modules/customer/pages/Login/Login";
import ForgetPassword from "@/modules/customer/pages/ForgetPassword/ForgetPassword";
import AuthLayout from "@/layouts/AuthLayout";
import UploadProfilePicture from "@/modules/customer/pages/UploadProfilePicture";
import VerifyEmail from "@/modules/customer/pages/VerifyEmail";
import VerifyForgetPassword from "@/modules/customer/pages/ForgetPassword/VerifyForgetPassword";
import ResetPassword from "@/modules/customer/pages/ForgetPassword/ResetPassword";

const customerAuthRoutes = [
  {
    path: "/customer/auth",
    element: <AuthLayout />,
    children: [
      { path: "login", element: <CustomerLogin /> },
      { path: "register", element: <CustomerRegister /> },
      { path: "forgot-password", element: <ForgetPassword /> },
      { path: "verify-email", element: <VerifyEmail /> },
      { path: "verify-reset-password-otp", element: <VerifyForgetPassword /> },
      { path: "reset-password", element: <ResetPassword /> },
    ],
  },
];

export default customerAuthRoutes;